import { render, staticRenderFns } from "./invitePk.vue?vue&type=template&id=1745104e&scoped=true"
import script from "./invitePk.vue?vue&type=script&lang=js"
export * from "./invitePk.vue?vue&type=script&lang=js"
import style0 from "./invitePk.vue?vue&type=style&index=0&id=1745104e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745104e",
  null
  
)

export default component.exports